import { combineReducers, configureStore } from '@reduxjs/toolkit';

import auth from './auth';
import contract from './contract';
import newContractProposal from './newContractProposal';
import user from './user';
import secondaryOperation from './secondary-operation';
import banking from './banking';
import beneficiaries from './beneficiaries';

export const authStore = configureStore({ reducer: auth });

const reducer = combineReducers({
  contract,
  newContractProposal,
  auth,
  user,
  secondaryOperation,
  banking,
  beneficiaries,
});

export type IRootState = ReturnType<typeof reducer>;
export default reducer;
